import React from "react";
import { FiArrowLeft, FiBarChart2, FiDownload } from "react-icons/fi";

export default function PowerBIPlugins() {
  const reports = [
    "Sales Summary",
    "Sales History",
    "Sales by Day of Week",
    "Sales by Shipping Address",
    "Order Overview",
    "Orders by Status",
    "Average Order Value",
    "Latest 20 Orders",
    "Top Products",
    "Monthly Performance",
    "Year-to-year comparison",
    "Customers",
    "Advanced Product Search",
  ];

  return (
    <div className="p-4 sm:p-6 bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
        <div className="flex items-center gap-3 text-gray-700">
          <button
            onClick={() => window.history.back()}
            className="flex items-center gap-1 text-blue-600 hover:text-blue-800 text-sm font-medium"
          >
            <FiArrowLeft /> Back to plugin list
          </button>
        </div>
        <h1 className="text-2xl font-semibold text-gray-800 flex items-center gap-2 mt-3 sm:mt-0">
          <FiBarChart2 className="text-blue-600" /> Power BI (Official Plugin)
        </h1>
      </div>

      {/* Plugin Description */}
      <div className="bg-white shadow-sm rounded-xl p-4 sm:p-6 space-y-4">
        <p className="text-gray-700 leading-relaxed">
          This Power BI integration by the <strong>routekart team</strong> provides businesses with
          advanced analytics, comprehensive reports, and real-time insights to optimize their daily
          operations.
        </p>
        <p className="text-gray-700 leading-relaxed">
          From detailed sales analysis and customer behavior tracking to geographical and order
          statuses, the plugin helps make informed decisions, enhance performance, and tailor
          strategies for growth.
        </p>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <p className="font-semibold text-blue-800 mb-2">
            The installation package includes 13 comprehensive reports covering key aspects of business data:
          </p>
          <ul className="list-disc pl-5 space-y-1 text-gray-700">
            {reports.map((report, index) => (
              <li key={index}>{report}</li>
            ))}
          </ul>
        </div>

        <p className="text-gray-700">
          The source code ensures the ability to customize existing reports and add new ones.
        </p>

        {/* Button */}
        <div className="pt-4">
          <button className="flex items-center gap-2 bg-blue-600 text-white px-5 py-2 rounded-lg hover:bg-blue-700 transition text-sm font-medium">
            <FiDownload /> Get the Plugin
          </button>
        </div>
      </div>
    </div>
  );
}
